import { GraphhopperClustering } from "./graphhopper-clustering";

export class GraphhopperConfiguration {
  
  response_type : string = 'json';
  routing       : any = {			
                          'profile'         : 'car',
                          'cost_per_second' : 0,
                          'cost_per_meter'  : 1
                        };
  clustering    : GraphhopperClustering = new GraphhopperClustering();;

}

